export enum FulfillmentEnum {
  OK = 'OK',
  ERROR = 'Error',
  LOADING = 'Loading'
}
